<template>
    <v-app id="inspire" ref="modal_recover">
        <v-layout row justify-center>

            <v-dialog
                v-model="dialog"
                max-width="290"
            >
                <v-card class="pa-4">
                    <v-card-text>
                        {{ modal_text }}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="push_to_home"
                        >
                            {{$t("Продолжить")}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex';
export default {

  computed: {
    ...mapGetters('autorisation', ['modal_active', 'modal_text']),
    dialog: {
      get() {
        return this.modal_active;
      },
      set(value) {
        this.SET_MODAL_RECOVER(value);
      },
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    push_to_home() {
      this.SET_MODAL_RECOVER(false);
      this.$router.push({name: 'auth'});
    },
    ...mapMutations('autorisation', ['SET_MODAL_RECOVER']),
  },

};
</script>
